const UserActionTypes = {
  SET_CURRENT_USER: "USER_SET_CURRENT_USER",
  SHOW_SYSTEM_MESSAGE: "USER_SHOW_SYSTEM_MESSAGE",
  LOGOUT: "USER_LOGOUT",
};

export default UserActionTypes;
